import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import LibyaService, { updateSubscriptionStorage } from "../../Utilies/Utilies/libyaService";
import { notify1 } from "../ToastComponent";
import { useTranslation } from "react-i18next";

const ReactiveSubscriptionModal = ({ show, onClose }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(show);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  // keep confirm modal in sync with parent show
  React.useEffect(() => {
    setShowConfirmModal(show);
  }, [show]);

  const sendOtp = async () => {
    try {
      setLoading(true);

      const res = await LibyaService.activateSubscriptionApi({
        phone: localStorage.getItem("msisdn"),
      });

      if (res?.data?.success === true) {
        setShowConfirmModal(false); // close confirm
        setShowOtpModal(true);      // open otp modal
      } else {
        notify1(res?.data?.message || "Something went wrong");
      }
    } catch (err) {
      notify1(
        err?.response?.data?.message || "Server error, please try again"
      );
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    try {
      setLoading(true);

      await LibyaService.verifyOtpApi({
        phone: localStorage.getItem("msisdn"),
        otp,
      });

      // Fetch updated subscription details and store in localStorage
      try {
        const res = await LibyaService.getSubDetails();
        if (res?.data?.data) {
          updateSubscriptionStorage(res.data.data);
        }
      } catch (e) {
        console.error("Failed to fetch updated subscription details:", e);
      }

      setShowOtpModal(false);
      onClose(); // close parent
      window.location.reload();
    } catch (err) {
      notify1(
        err?.response?.data?.message || "Invalid OTP"
      );
    } finally {
      setLoading(false);
    }
  };
 const allowOnlyNumbers = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };
  return (
    <>
      {/* ===== Modal 1: Confirm Send OTP ===== */}
      <Modal show={showConfirmModal} onHide={onClose} centered>
        <Modal.Header closeButton>
        </Modal.Header>

       <Modal.Body>
  <p>
    {t("subscription_reactivate_message")}
    <br />
{/*     <strong>{t("subscription_send_otp_hint")}</strong>
 */}  </p>
</Modal.Body>


       <Modal.Footer className="d-flex flex-column gap-2">
 

  <Button
    className="w-100 text-center"
    onClick={sendOtp}
    disabled={loading}
  >
    {loading ? t("sending") : t("renewal")}
  </Button>
  <Button
    className="w-100"
    variant="secondary"
    onClick={onClose}
  >
    {t("cancel")}
  </Button>
</Modal.Footer>

      </Modal>

      {/* ===== Modal 2: Enter OTP ===== */}
     <Modal show={showOtpModal} onHide={() => setShowOtpModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>{t("enter_otp_title")}</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <input
      className="form-control"
      maxLength="4"
                    onKeyPress={allowOnlyNumbers}

      placeholder={t("enter_otp_placeholder")}
      value={otp}
      onChange={(e) => setOtp(e.target.value)}
    />
  </Modal.Body>

 <Modal.Footer>
  <Button
    className="w-100 text-center"
    onClick={verifyOtp}
    disabled={loading || !otp}
  >
    {loading ? t("verifying") : t("confirm")}
  </Button>
</Modal.Footer>

</Modal>

    </>
  );
};

export default ReactiveSubscriptionModal;
